import axios from 'axios';
import { notification } from 'antd';

import { ACTION_TYPES } from './constants';

const baseUrl = process.env.REACT_APP_API_URL;

const config = {
  headers: { Authorization: '' },
};

export const logoutAction = () => (dispatch) => {
  localStorage.removeItem('token');
  localStorage.removeItem('workspaceId');
  localStorage.removeItem('organization');
  localStorage.removeItem('toggle');
  localStorage.removeItem('inviteUrl');
  localStorage.removeItem('Id');

  sessionStorage.removeItem('workspaceId');
  sessionStorage.removeItem('organization');
  window.location.href = '/signin';

  dispatch({ type: ACTION_TYPES.LOGOUT });
};

// Formerly saveUserFilter
export const saveCustomTasksFilterAction = (
  filters = {},
  filterName,
  intl,
  cb,
) => {
  return async (dispatch) => {
    try {
      const workspaceId = sessionStorage.getItem('workspaceId');
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      const body = {
        query: filters,
        workspace: workspaceId,
        name: filterName,
      };
      const res = await axios.post(`${baseUrl}/filter`, body, config);
      cb && cb(res.data.data);
      // TODO: better to use action and directly save in store based on the payload instead of calling api again
      dispatch(getCustomTasksFiltersAction(workspaceId));
      // dispatch({
      //   type: ACTION_TYPES.SAVE_CUSTOM_TASKS_FILTER,
      //   payload: res.data.data,
      // });
      notification.success({
        message: intl.formatMessage({
          id: 'FILTER_SAVED',
          defaultMessage: 'The filter was saved successfully!',
        }),
        placement: 'bottomRight',
      });
    } catch (error) {
      notification.error({
        message: intl.formatMessage({
          id: 'UNABLE_TO_SAVE_FILTER',
          defaultMessage: 'Unable to save filter',
        }),
        placement: 'bottomRight',
      });
    }
  };
};

// Formerly getUserFilters
export const getCustomTasksFiltersAction = (workspaceId) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;

      const res = await axios.get(`${baseUrl}/filter/${workspaceId}/user`, config);

      dispatch({
        type: ACTION_TYPES.GET_CUSTOM_TASKS_FILTERS, //'getUserFilters',
        payload: res.data.data,
      });
    } catch (error) {
      // TODO: intl
      notification.error({
        message: 'Unable to get filters',
        placement: 'bottomRight',
      });
    }
  };
};

// Formerly editUsersCustomFilter
export const editCustomTasksFilterAction = (filter, filterName, cb) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      const res = await axios.put(
        `${baseUrl}/filter/${filter._id}`,
        {
          name: filterName,
          query: filter.query,
        },
        config,
      );
      // TODO: better to use action and directly save in store based on the payload instead of calling api again
      const workspaceId = sessionStorage.getItem('workspaceId');
      dispatch(getCustomTasksFiltersAction(workspaceId));
      cb && cb(res.data.data);
      // TODO: intl
      notification.success({
        message: 'Filter updated successfully',
        placement: 'bottomRight',
      });
    } catch (error) {
      // TODO: intl
      notification.error({
        message: 'Unable to edit filter',
        placement: 'bottomRight',
      });
    }
  };
};

// Formerly deleteUsersCustomFilter
export const deleteCustomTasksFilterAction = (filterId) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      await axios.delete(`${baseUrl}/filter/${filterId}`, config);

      // TODO: better to use action and directly save in store based on the payload instead of calling api again
      const workspaceId = sessionStorage.getItem('workspaceId');
      dispatch(getCustomTasksFiltersAction(workspaceId));
      // TODO: intl
      notification.success({
        message: 'Filter deleted successfully',
        placement: 'bottomRight',
      });
    } catch (error) {
      // TODO: intl
      notification.error({
        message: 'Unable to delete filter',
        placement: 'bottomRight',
      });
    }
  };
};

export const deleteUserFilterResultsAction = (taskId) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPES.DELETE_USER_FILTER_RESULTS, //'delete-user-filter-results',
      payload: taskId,
    });
  };
};

export const addToUserFilterResultsAction = (task) => {
  return (dispatch) => {
    const currentWS = sessionStorage.getItem('workspaceId');
    if (task?.workspace?.toString() === currentWS?.toString()) {
      dispatch({
        type: ACTION_TYPES.ADD_TASK_TO_USER_FILTER_RESULTS,
        payload: task,
      });
    }
  };
};

export const setVisibleSectionIdListAction = (sectionIdList) => ({
  type: ACTION_TYPES.SET_VISIBLE_SECTION_ID_LIST,
  payload: {
    sectionIdList,
  },
});

export const removeFromVisibleSectionIdListAction = (sectionId) => ({
  type: ACTION_TYPES.REMOVE_FROM_VISIBLE_SECTION_ID_LIST,
  payload: {
    sectionId,
  },
});

export const clearVisibleSectionIdListAction = () => ({
  type: ACTION_TYPES.CLEAR_VISIBLE_SECTION_ID_LIST,
});
